import { Box, Button, ComposableTypography, ComposedElement } from '@bcp-nextgen-dx-component-factory/design-system';
import { NavClose } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { ExclamationCircle } from '@components';
import { UIHelper } from '@helpers';
import { useModal, useTranslation } from '@hooks';

import { Modals } from '..';
import { AppModal } from '../base';

interface GenericErrorModalProps {
	title?: string;
	message?: string;
}

const MODAL_NAME: Modals = 'genericError';

export const GenericErrorModal = ({ title, message }: GenericErrorModalProps) => {
	const { t } = useTranslation();
	const modal = useModal(MODAL_NAME);

	const hideModal = () => {
		modal.hide();
	};

	return (
		<AppModal modalName={MODAL_NAME} visible={modal.isVisible}>
			<Box
				sx={{
					type: 'responsive',
					'@base': {
						position: 'relative',
						flexDirection: 'column',
						bg: 'color_01.50',
						br: 'xSmall',
						p: UIHelper.rem(48, 24, 42),
						m: UIHelper.rem(16),
						minWidth: UIHelper.rem(300),
						maxWidth: UIHelper.rem(486),
					},
					'@desktop': {
						p: UIHelper.rem(72, 36),
						minWidth: UIHelper.rem(486),
						maxWidth: UIHelper.rem(558),
					},
				}}
			>
				<Box
					onPress={hideModal}
					styles={{
						position: 'absolute',
						top: UIHelper.rem(24),
						right: UIHelper.rem(24),
						cursor: 'pointer',
					}}
				>
					<ComposedElement
						size="big"
						icon={{ source: NavClose.Outline }}
						fill="color_01.400"
						sizeOverride={{
							height: UIHelper.rem(24),
							width: UIHelper.rem(24),
						}}
					/>
				</Box>

				<Box
					styles={{
						flexDirection: 'column',
						alignItems: 'center',
						textAlign: 'center',
						gap: UIHelper.rem(32),
					}}
				>
					<ComposedElement size="big" icon={{ source: ExclamationCircle }} />

					<Box
						styles={{
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							gap: UIHelper.rem(16),
						}}
					>
						<ComposableTypography
							baseProps={{
								appearance: 'subtitle-100-04',
							}}
							text={title || t('modals.genericError.title')}
							tags={{}}
						/>

						<ComposableTypography
							baseProps={{
								appearance: 'body-100-02',
							}}
							text={message || t('modals.genericError.message')}
							tags={{}}
						/>
					</Box>

					<Button size="large" onPress={hideModal}>
						{t('modals.genericError.button.label')}
					</Button>
				</Box>
			</Box>
		</AppModal>
	);
};
